import { Button, Message } from '@meitu/saas-ui';
import { Editor } from '@meitu/saas-editor-core';
import { MAX_COL_COUNT, MAX_ROW_COUNT } from '@meitu/saas-editor-core/es/layers/table-layer/default-configs';
import { tableFileTypes } from '@meitu/saas-editor-core/es/plugins/table-edit/utils/native';
import { isSafari } from '@meitu/saas-editor-core/es/utils/browser-kit';
import { useLocaleStore } from '@/i18n';
import './import-excel.less';
import IconFont from '@meitu/xdesign-icon-font';

interface IImportExcelProps {
    editor: Editor;
}

const ImportExcel: React.FC<IImportExcelProps> = ({ editor }) => {
    const { $t } = useLocaleStore();

    const handleImportExcel = async () => {
        const file = await easyUpload();
        if (!file) return;
        editor.tip.showMask({ loading: true });
        try {
            await editor.tableLayer.addTableLayerByExcel(file);
        } catch (error) {
            console.log('===error', error);
        } finally {
            editor.tip.hideMask();
        }
    };

    const easyUpload = () =>
        new Promise<File>((resolve, reject) => {
            const input = document.createElement('input');
            input.type = 'file';
            if (!isSafari) {
                input.accept =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, '',";
            }

            document.body.appendChild(input);

            input.onchange = function () {
                const { files } = input;
                if (!files?.length) return;
                const file = files[0];
                // safari存在file.type为空的情况, 所以file.type为空时, 需要直接走解析流程
                if (file.type && !tableFileTypes.includes(file.type)) {
                    Message.error($t((v) => v.collapse.moreCollapse.componentTool.table.messageError.filetypeLimit));
                    return;
                }
                resolve(file);
                input.remove();
            };
            input.onerror = (e) => {
                reject(e);
            };
            input.click();
        });

    return (
        <div className="import-import-btn" onClick={handleImportExcel}>
            <Button
                icon={<IconFont name="UploadBold" color="var(--content-function-tool-nav, #9FA1A6)" fontSize={16} />}
            >
                {$t((v) => v.collapse.moreCollapse.componentTool.table.importExcel)}
            </Button>
            <span className="tip">
                {$t((v, { r }) =>
                    r(v.collapse.moreCollapse.componentTool.table.importExcelLimit, [MAX_ROW_COUNT, MAX_COL_COUNT]),
                )}
            </span>
        </div>
    );
};

ImportExcel.displayName = 'ImportExcel';

export default ImportExcel;
